<template>
  <!-- OCR読み込みファイル確認 -->
  <ModalDialog
    dialog-width="90%"
    dialog-height="auto"
    margin-class="mtp-3 mbm-3"
    pop-name="OCR読み込みファイル確認"
    @close="closeModal"
  >
    <template #header> </template>

    <template #body>
      <div class="mtp-3">
        <Pagination class="mbm-3" :list="list"></Pagination>
        <div class="d-flex justify-content-center">
          全{{ list.length }}ページ中1ページ目表示
        </div>
        <div
          v-for="(item, index) in list"
          v-show="edit"
          :key="index"
          class="mtp-1"
        >
          <div style="display: flex">
            <div
              class="border-start border-top border-end d-flex align-items-center"
              style="height: 25px; width: calc(13%)"
            >
              &nbsp;ファイル名
            </div>
            <div
              class="border-end border-top d-flex align-items-center"
              style="height: 25px; width: calc(37%)"
            >
              &nbsp;{{ item.name }}
            </div>
          </div>

          <textarea
            v-model="item.content"
            class="form-control"
            style="
              height: 570px;
              width: 100%;
              overflow: auto;
              text-align: center;
              line-height: 555px;
            "
            placeholder=""
          ></textarea>
        </div>

        <div
          v-for="(item, index) in list"
          v-show="!edit"
          :key="index"
          class="mtp-1"
        >
          <div style="display: flex">
            <div
              class="border-start border-top border-end d-flex align-items-center"
              style="height: 25px; width: calc(13%)"
            >
              &nbsp;ファイル名
            </div>
            <div
              class="border-end border-top d-flex align-items-center"
              style="height: 25px; width: calc(37%)"
            >
              &nbsp;{{ item.name }}
            </div>
          </div>

          <textarea
            v-model="item.content"
            class="form-control"
            style="
              height: 500px;
              width: 100%;
              overflow: auto;
              text-align: center;
              line-height: 500px;
            "
            placeholder=""
          ></textarea>
        </div>
      </div>
    </template>

    <template #footer>
      <div v-show="edit">
        <div class="d-flex justify-content-center">
          <ButtonMain button-name="閉じる" @click="closeModal"></ButtonMain>
        </div>
      </div>
      <div v-show="!edit">
        <div class="d-flex justify-content-center">
          <ButtonMain button-name="閉じる"></ButtonMain>
        </div>
      </div>
    </template>
  </ModalDialog>
</template>
<script>
export default {
  name: 'CheckOCRReadFileDialogZS',
  props: {
    list: Array
  },
  data() {
    return {
      edit: true
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    update() {
      this.edit = false
    }
  }
}
</script>
<style scoped lang="scss"></style>
